import $ from "jquery";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import { getRoomStatus } from "@bd-stores/game-progress";
import { setRoomFinished } from "@bd-core/firebase-actions";
import { getState } from "@bd-stores/store";

export default class RoomTimer {
    constructor(timeoutCallback) {
        this.roomId = null;
        this.roomTimer = 0;
        this.timeoutCursor = null;
        this.isTimeout = false;
        this.timeoutCallback = timeoutCallback;
        this.elms = {
            timerBox: ".js-timer",
            timer: ".js-timer-text",
            timerRemaining: ".js-timer .timer__remaining",
            popupHint: ".js-popup-timerhint",
        };
    }

    init(roomId, finishedAt = null) {
        const gameProgress = getState().gameProgress;
        const roomStatus = getRoomStatus(roomId);

        /* register close events */
        const $popup = $(this.elms.popupHint);
        $popup.find(".js-close-hint").on("click", this.hideNotif.bind(this));

        this.roomId = roomId;
        const rooms = CONFIG?.game?.rooms || false;

        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);

        if (!room) return;

        let self = this;

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
        }

        const timer = room?.room?.time_config?.timer || 0;
        const notifications = room?.room?.time_config?.notifications || [];
        const roomType = room?.type;

        this.roomTimer = timer;
        const cfgLimit = timer * 60;
        // const getCurrentTime = () => new Date(Date.now()).getTime();
        // const timeLimit = new Date(
        //     getCurrentTime() + this.getTimeLeft() * 1000,
        // );

        const timeLeft = gameProgress.currentRoomShouldFinisheddAt - Math.floor(Date.now() / 1000); //timeLimit.getTime() - getCurrentTime();

        const toTimeObject = (time) => {
            // const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
            // const minutes = Math.floor((time / 1000 / 60) % 60);
            // const seconds = Math.floor((time / 1000) % 60);

            const hours = Math.floor((time / (60 * 60)) % 24);
            const minutes = Math.floor((time / 60) % 60);
            const seconds = Math.floor((time) % 60);

            return {
                h: hours.toString().padStart(2, "0"),
                m: minutes.toString().padStart(2, "0"),
                s: seconds.toString().padStart(2, "0"),
            };
        };

        const updateTimer = (h, m, s, percent) => {
            const allowedRoomType = [
                "teamconnector_room",
                "end_game"
            ];

            if (!allowedRoomType.includes(roomType)) return;

            const txtH = h !== "00" ? `${h}:` : "";
            let txtTimer = `${txtH}${m}:${s}`;

            percent = percent < 0 ? 0 : percent;
            
            $(self.elms.timer).text(txtTimer);
            $(self.elms.timerRemaining).css("width", percent + "%");
        };

        if (roomStatus === "is-status-completed") {
            if(finishedAt) {
                const time = gameProgress.currentRoomShouldFinisheddAt - finishedAt;
                const percentage = (100 * time) / cfgLimit;
                const objTimer = toTimeObject(time);
                updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);
            }
            return false;
        }

        if (timeLeft <= 0) {
            updateTimer("00", "00", "00", "100");
            return false;
        }

        this.timeoutCursor = setInterval(() => {
            const time = gameProgress.currentRoomShouldFinisheddAt - Math.floor(Date.now() / 1000); // timeLimit.getTime() - getCurrentTime();
            const percentage = (100 * time) / cfgLimit;
            const objTimer = toTimeObject(time);

            $.each(notifications, function (index, item) {
                const hours = Math.floor(item.minutes_before_end / 60)
                    .toString()
                    .padStart(2, "0");
                const minutes = Math.floor(item.minutes_before_end % 60)
                    .toString()
                    .padStart(2, "0");

                if (
                    objTimer.h == hours &&
                    minutes == objTimer.m &&
                    objTimer.s == "00"
                ) {
                    self.showNotif(
                        item.notification_title,
                        item.time_notification_text,
                    );
                    notifications.splice(index, 1);
                    return false;
                }
            });

            if (time < 1) {
                this.isTimeout = true;

                if (self.timeoutCursor) {
                    clearInterval(self.timeoutCursor);
                    updateTimer('00', '00', '00', '100');
                }

                if (typeof self.timeoutCallback == "function")
                    self.timeoutCallback();
            }

            updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);
            this.setTimeLeft(Math.floor(Number(time) / 1000));
        }, 1000);

        // Perform timer calculation immediately before the interval
        const time = gameProgress.currentRoomShouldFinisheddAt - Math.floor(Date.now() / 1000); //timeLimit.getTime() - getCurrentTime();
        const objTimer = toTimeObject(time);
        const percentage = (100 * time) / cfgLimit;
        updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);

        return this;
    }

    showNotif(title, text) {
        const $popup = $(this.elms.popupHint);

        $popup.find(".js-hint-title").text(title);
        $popup.find(".js-hint-content").html(text);
        $popup.addClass("is-open");
    }

    hideNotif() {
        const $popup = $(this.elms.popupHint);
        $popup.removeClass("is-open");
    }

    stopTimer(roomId) {
        if (this.timeoutCursor === null) return;

        // let timeSpend = Number(this.roomTimer * 60);

        // if (!this.isTimeout) {
        //     timeSpend = this.getTimeLeft();
        // }

        // setTimeSpentToFinish(roomId, timeSpend);
        setRoomFinished(roomId);
        clearInterval(this.timeoutCursor);
        this.timeoutCursor = null;

        return roomId;
    }

    getTimeLeft() {
        const roomId = this.roomId;
        const timer = this.roomTimer * 60;
        const states = Storage.get("states", {});
        const savedTimeLeft = states?.timeLeft?.[roomId] || timer;

        return savedTimeLeft;
    }

    setTimeLeft(timeLeft) {
        const roomId = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.timeLeft) states.timeLeft = {};
        if (!states?.timeLeft?.[roomId]) states.timeLeft[roomId] = 0;

        states.timeLeft[roomId] = timeLeft;

        return Storage.set("states", states);
    }
}
